import { render, staticRenderFns } from "./SellerAddProduct.vue?vue&type=template&id=6f4a5cb6&scoped=true"
import script from "./SellerAddProduct.vue?vue&type=script&lang=js"
export * from "./SellerAddProduct.vue?vue&type=script&lang=js"
import style0 from "./SellerAddProduct.vue?vue&type=style&index=0&id=6f4a5cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a5cb6",
  null
  
)

export default component.exports